import * as React from 'react';
import Box from '@mui/material/Box';
import { useMeasure } from 'react-use';
import { DocumentMeta } from './SolicitorDocumentPage';
import mergeRefs from 'merge-refs';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { Grid } from '@mui/material';

// import { SinglePacketDocumentViewerFooter } from './components/Footer';

const ResponsiveDrawer: React.FC<Props> = React.forwardRef(
    (props, ref): React.ReactElement => {
        const {
            Footer,
            children,
            innerRef,
            mainContainerRef,
            onChangedStepFooter,
            onChangedCategoryFooter,
            onClickStepFooter,
            onChangeDropdownChecklistStepFooter,
        } = props;
        const [isHidden, setHidden] = React.useState<boolean>(false);
        const [measureRef, { width: measureWidth, height: measureHeight }] =
            useMeasure<HTMLDivElement>();
        const navRef = React.useRef<null | HTMLElement>(null);
        const DocumentMetaProps = React.useContext(DocumentMeta);
        React.useImperativeHandle(
            ref,
            () => ({
                /**
                 * hide footer
                 */
                setHidden: () => {
                    setHidden(true);
                },
                /**
                 * show footer
                 */
                setShow: () => {
                    setHidden(false);
                },
                getMeasureFooter: () => ({
                    width: measureWidth,
                    height: measureHeight,
                }),
            }),
            [measureHeight, measureWidth]
        );

        React.useLayoutEffect(() => {
            if (DocumentMetaProps) {
                const nav = navRef.current?.getBoundingClientRect();
                if (nav) {
                    DocumentMetaProps?.setFooterMeasurement({
                        width: nav.width,
                        height: nav.height,
                    });
                }
            }
        }, [measureHeight, measureWidth]);
        return (
            <Box
                className="footer-wrapper document-solicitor-container"
                ref={mainContainerRef}
            >
                <Box
                    component="main"
                    aria-label="container with footing menu"
                    className="main-content"
                >
                    {children}
                </Box>
                <Box
                    component="nav"
                    ref={mergeRefs(measureRef, navRef)}
                    className={
                        isHidden
                            ? 'footer-container hidden'
                            : 'footer-container'
                    }
                >
                    <Footer
                        ref={innerRef}
                        onStepClicked={onClickStepFooter}
                        onStepChanged={onChangedStepFooter}
                        onChangedDropdown={onChangeDropdownChecklistStepFooter}
                        onValidationCategoryChanged={onChangedCategoryFooter}
                    />
                </Box>
                <Grid container>
                    <Grid item xs={10} />
                    <Grid item xs={2}>
                        <Box className="justify-end pl-5 pt-0 pb-8 pr-8">
                            <AppPrimaryButton
                                title="View Alfy"
                                fullWidth
                                className="btn-small f11"
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        );
    }
);

export default ResponsiveDrawer;
